import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { LookupModel } from '../../models/common/lookup.model';

@Component({
  selector: 'app-sale-horse-status-modal',
  templateUrl: './sale-horse-status-modal.component.html',
  styleUrls: ['./sale-horse-status-modal.component.scss'],
})
export class SaleHorseStatusModalComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() data: any;
  saleHorseForm: FormGroup;
  statuses: LookupModel[];

  /*statuses = [
    { id: 0, label: 'No Result' },
    { id: 1, label: 'Sold' },
    { id: 2, label: 'Passed In' },
    { id: 3, label: 'Withdrawn' },
    { id: 4, label: 'Withdrawn At Sale' },
    { id: 5, label: 'Private Sale' },
  ];*/
  constructor(public readonly modal: NgbActiveModal, private changeDetectorRefs: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.statuses = this.data.saleStatuses;
    const withdraw = this.statuses[3].id;
    const withdrawAtSale = this.statuses[4].id;
    /*if (this.data.sale.lotOrHipText == 'HIP') {
      this.statuses = this.statuses.map((status) => {
        if (status.id ==  2 && status.label == 'Passed In') {          
          status.label = 'RNA';
          if (this.data.horse.saleResult == passedin) {
            this.data.horse.saleResult = status.id;
          }
        }
        return status;
      });
    }*/
    if (this.data.horse.eitherStatusID === this.data.horse.status) {
      let price = new FormControl(this.data.horse.price, [
        Validators.required,
        Validators.min(0),
      ]);
      let buyer = new FormControl(this.data.horse.buyer, [Validators.required]);

      if (this.data.horse.status == withdraw || this.data.horse.status == withdrawAtSale) {
        price = new FormControl(this.data.horse.price);
        buyer = new FormControl(this.data.horse.buyer)
      }
      this.saleHorseForm = new FormGroup({
        status: new FormControl(
          this.data.horse.status,
          Validators.required
        ),

        price: new FormControl(this.data.horse.price),
        reservePrice: new FormControl(this.data.horse.reservePrice),
        buyer: new FormControl(this.data.horse.buyer),
        dateSold: new FormControl(this.data.horse.dateSold ?? ''),
      });
    }
    else {
      let price = new FormControl(this.data.horse.catalogPrice, [
        Validators.required,
        Validators.min(0),
      ]);
      let buyer = new FormControl(this.data.horse.catalogPurchaser, [Validators.required]);

      if (this.data.horse.eitherStatusID == withdraw || this.data.horse.eitherStatusID == withdrawAtSale) {
        price = new FormControl(this.data.horse.catalogPrice);
        buyer = new FormControl(this.data.horse.catalogPurchaser);
      }
      this.saleHorseForm = new FormGroup({
        status: new FormControl(
          this.data.horse.eitherStatusID,
          Validators.required
        ),

        price: new FormControl(this.data.horse.catalogPrice),
        reservePrice: new FormControl(this.data.horse.catalogReservePrice),
        buyer: new FormControl(this.data.horse.catalogPurchaser),
        dateSold: new FormControl(this.data.horse.dateSold ?? ''),
      });
    }
    this.saleHorseForm.updateValueAndValidity();
    this.changeDetectorRefs.detectChanges();
  }
  isShowPrice() {
    var statusId = parseInt(this.saleHorseForm.value.status);
    return statusId === 1 || statusId === 2 || statusId === 5;
  }
  isShowBuyer() {
    var statusId = parseInt(this.saleHorseForm.value.status);
    return statusId === 1 || statusId === 2 || statusId === 5;
  }
  isShowDateSold() {
    var statusId = parseInt(this.saleHorseForm.value.status);
    return statusId === 1 || statusId === 2 || statusId === 3 || statusId === 4 || statusId === 5;
  }
  statusChanged() {
    var statusId = parseInt(this.saleHorseForm.value.status);
    if (statusId === 0) {
      this.saleHorseForm.patchValue({ buyer: null, price: null });
      //this.saleHorseForm.value.buyer =''; this.saleHorseForm.value.price = '';
    }
    else if (statusId === 3 || statusId === 4) {
      //  this.saleHorseForm.value.buyer = '';this.saleHorseForm.value.price = '';
      this.saleHorseForm.patchValue({ buyer: null, price: null });
    }
  }
  onSave() {
    if (this.saleHorseForm.valid) {
      const formData = this.saleHorseForm.value;
      this.data.horse.status = formData.status;
      this.data.horse.price = formData.price;
      this.data.horse.reservePrice = formData.reservePrice;
      this.data.horse.buyer = formData.buyer;
      this.data.horse.dateSold = formData.dateSold;
      this.modal.close(this.data.horse);
    }
  }
}
